import { withBasePath } from "@/lib/basePath";

interface IconProps {
  name: string;
  size?: number;
  className?: string;
}

export default function Icon({ name, size = 24, className }: IconProps) {
  return (
    <svg
      className={`icon${className ? ` ${className}` : ''}`}
      width={size}
      height={size}
      aria-hidden="true"
    >
      <use href={`${withBasePath("/icons/sprite.svg")}#${name}`} />
    </svg>
  );
}
